import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class ModuleText extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <g>
            <path d="M6.4,10.6l1.2-0.1V3.9L5.8,4L5.5,4.9L5,4.9l0.1-1.5H11l0,1.5l-0.4,0L10.3,4L8.5,3.9v6.5l1.3,0.1V11H6.4V10.6z" />
          </g>
          <polygon points="13.4,12.6 2.6,12.6 2.3,12.3 2.3,11.5 2.9,11.5 2.9,12 13.1,12 13.1,11.5 13.7,11.5 13.7,12.3   " />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/ModuleText.js